export default function menuItem({ variables }) {
    return {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    padding: `${variables.spacing_02} ${variables.spacing_05}`,
                    "&.MuiMenuItem-root.Mui-selected": {
                        fontWeight: variables.font_weight_medium,
                        backgroundColor: variables.surface_selected,
                    },
                    "&.MuiMenuItem-root:hover": {
                        backgroundColor: variables.surface_selected_hover,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=menuItem.js.map